import client from './client'

export default {
  // service wechatId
  async serverWechat () {
    const url = '/public/app/config'
    const res = await client.get(url)
    return res.data.data
  },
  async shareRecord (params) {
    const url = '/points/completeDailyTask'
    const res = await client.post(url, params)
    return res.data.data
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/service.js